export default __webpack_public_path__ + "static/media/keto_thirst@2x.4ef53d6b.jpg";